import React, { useCallback, useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Modal from 'react-modal';
import Button from 'react-bootstrap/Button';
import {
  FiExternalLink, FiChevronDown,
  FiFileText, FiGlobe, FiActivity, FiPieChart, FiUpload, FiDownload,
} from 'react-icons/fi';
import Zapi from '../../components/api/api';
import Zcompnfe from '../../components/api/compnfe';
import Zmonitoramento from '../monitoramento/monitoramento';
import ListaRegistros from '../pdvexception/list';
import ListaRegistrosDev from '../pdvexception/listdev';
import ZDashboard from '../monitoramento/dashboard';
import ZUpload from '../monitoramento/upload';
import ZDownload from '../monitoramento/download';
import ServidoresAWS from '../monitoramento/servidoresaws';
import Menu from '../menu';
import DashboardKPIs from './DashboardKPIs';

Modal.setAppElement('#root');

const COMPSOFT_ITEMS = [
  { label: 'Compnfe/CTe', icon: <FiFileText size={13} />, component: <Zcompnfe /> },
  { label: 'Zaniboni',    icon: <FiGlobe    size={13} />, component: <Zapi /> },
  { label: 'Monitor',     icon: <FiActivity size={13} />, component: <Zmonitoramento /> },
  { label: 'Dashboard',   icon: <FiPieChart size={13} />, component: <ZDashboard /> },
  { label: 'Upload' ,      icon: <FiUpload   size={13} />, component: <ZUpload /> },
  { label: 'Download',    icon: <FiDownload size={13} />, component: <ZDownload /> },
];

export default function Principal() {
  const [clock, setClock]           = useState(() => new Date());
  const [open, setOpen]             = useState({ proprio: true, compsoft: true });
  const [filtroNivel, setFiltroNivel] = useState(null);
  const location                    = useLocation();

  const userRole = localStorage.getItem('user-role');
  const isMaster = userRole === 'MASTER';

  const NAV_LINKS = [
    { to: '/',           label: 'Home' },
    { to: '/pdv',        label: 'PDV' },
    { to: '/lics',       label: 'Licenças' },
    { to: '/ver',        label: 'Versões' },
    { to: '/csapi',      label: 'Produtos AZ' },
    ...(isMaster ? [
      { to: '/auditoria', label: 'Auditar' },
      { to: '/update',    label: 'Update' },
    ] : []),
  ];

  useEffect(() => {
    const t = setInterval(() => setClock(new Date()), 1000);
    return () => clearInterval(t);
  }, []);

  const toggle = useCallback(key => {
    setOpen(prev => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const openExternalPage = useCallback(() => {
    window.open('https://csdash-alpha.vercel.app/', '_blank', 'noopener,noreferrer');
  }, []);

  const dateStr = clock.toLocaleDateString('pt-BR', { weekday: 'long', day: 'numeric', month: 'long' });
  const timeStr = clock.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit', second: '2-digit' });

  return (
    <>
      <Menu />

      <div id="cs-layout">

        {/* Painel esquerdo */}
        <div id="cs-sidebar">
          <div className="d-flex flex-column gap-1 py-1">

            {/* Navegação — visível só no mobile */}
            <div className="cs-mobile-nav">
              <span className="cs-section-label">Navegação</span>
              <div className="cs-card">
                {NAV_LINKS.map(({ to, label }) => (
                  <Link
                    key={to}
                    to={to}
                    className={`cs-mobile-nav-link${location.pathname === to ? ' cs-mobile-nav-active' : ''}`}
                  >
                    {label}
                  </Link>
                ))}
              </div>
            </div>

            {/* AWS Próprio */}
            <div>
              <button className="cs-section-toggle" onClick={() => toggle('proprio')}>
                AWS Próprio
                <FiChevronDown size={12} className={`cs-chevron${open.proprio ? '' : ' cs-chevron-collapsed'}`} />
              </button>
              {open.proprio && (
                <div className="cs-card">
                  <ServidoresAWS />
                </div>
              )}
            </div>

            {/* AWS Compsoft */}
            <div>
              <button className="cs-section-toggle" onClick={() => toggle('compsoft')}>
                AWS Compsoft
                <FiChevronDown size={12} className={`cs-chevron${open.compsoft ? '' : ' cs-chevron-collapsed'}`} />
              </button>
              {open.compsoft && (
                <div className="cs-card">
                  {COMPSOFT_ITEMS.map(({ label, icon, component }) => (
                    <div key={label} className="cs-item">
                      <span className="cs-item-label">
                        <span className="cs-item-icon">{icon}</span>
                        {label}
                      </span>
                      <span>{component}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Compsoft */}
            <div>
              <span className="cs-section-label">Compsoft</span>
              <Button
                variant="outline-primary"
                onClick={openExternalPage}
                className="cs-btn-external"
              >
                <FiExternalLink size={11} />
                Acessar CSDash
              </Button>
            </div>

          </div>
        </div>

        {/* Conteúdo principal */}
        <div id="cs-main">
          <div className="cs-page-header">
            <div>
              <span className="cs-page-title">Monitoramento PDV</span>
              <span className="cs-page-subtitle">{dateStr}</span>
            </div>
            <span className="cs-page-clock">{timeStr}</span>
          </div>

          <DashboardKPIs filtroNivel={filtroNivel} onFilterNivel={setFiltroNivel} />

          <div className="cs-main-card">
            <ListaRegistros filtroNivel={filtroNivel} />
          </div>
          <div className="cs-main-card">
            <ListaRegistrosDev filtroNivel={filtroNivel} />
          </div>
        </div>

      </div>
    </>
  );
}
